export default __webpack_public_path__ + "content/media/IcoEmail.e93c7b4a.svg";